/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.14.1-13-ge76df34-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SetupStateFromJSON, SetupStateToJSON, } from './SetupState';
import { PortsInfoFromJSON, PortsInfoToJSON, } from './PortsInfo';
/**
 * Check if a given object implements the Info interface.
 */
export function instanceOfInfo(value) {
    if (!('ports' in value) || value['ports'] === undefined)
        return false;
    if (!('authorizedViaTicket' in value) || value['authorizedViaTicket'] === undefined)
        return false;
    if (!('authorizedViaSsoWithSingleLogout' in value) || value['authorizedViaSsoWithSingleLogout'] === undefined)
        return false;
    if (!('ownCredentialManagementAllowed' in value) || value['ownCredentialManagementAllowed'] === undefined)
        return false;
    return true;
}
export function InfoFromJSON(json) {
    return InfoFromJSONTyped(json, false);
}
export function InfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'version': json['version'] == null ? undefined : json['version'],
        'username': json['username'] == null ? undefined : json['username'],
        'selectedTarget': json['selected_target'] == null ? undefined : json['selected_target'],
        'externalHost': json['external_host'] == null ? undefined : json['external_host'],
        'ports': PortsInfoFromJSON(json['ports']),
        'authorizedViaTicket': json['authorized_via_ticket'],
        'authorizedViaSsoWithSingleLogout': json['authorized_via_sso_with_single_logout'],
        'ownCredentialManagementAllowed': json['own_credential_management_allowed'],
        'setupState': json['setup_state'] == null ? undefined : SetupStateFromJSON(json['setup_state']),
    };
}
export function InfoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'version': value['version'],
        'username': value['username'],
        'selected_target': value['selectedTarget'],
        'external_host': value['externalHost'],
        'ports': PortsInfoToJSON(value['ports']),
        'authorized_via_ticket': value['authorizedViaTicket'],
        'authorized_via_sso_with_single_logout': value['authorizedViaSsoWithSingleLogout'],
        'own_credential_management_allowed': value['ownCredentialManagementAllowed'],
        'setup_state': SetupStateToJSON(value['setupState']),
    };
}
